import { createTheme } from '@material-ui/core';
import { toCssValue } from '@topconagriculture/theme';
export const getMuiTheme = (theme, compact, withHeader) => createTheme({
    overrides: {
        MuiTable: {
            root: {
                borderRadius: withHeader ? 0 : '5px 5px 0 0',
                overflow: withHeader ? 'auto' : 'hidden',
            },
        },
        MuiPaper: {
            root: {},
        },
        MuiToolbar: {
            root: {
                backgroundColor: theme.components.table.header.background,
                color: theme.components.table.header.color,
                border: 'none',
                borderRadius: toCssValue([5, 5, 0, 0]),
                minHeight: '42px !important',
                paddingLeft: '20px !important',
            },
        },
        MuiTypography: {
            h6: {
                fontSize: 14,
                fontFamily: theme.font.family,
                fontWeight: theme.font.weight.bold,
                textTransform: 'uppercase',
            },
        },
        MuiInput: {
            underline: {
                outline: '0 !important',
                marginTop: '0 !important',
                borderBottom: '1px solid #ccc',
                '&::before': {
                    borderBottom: '1px solid white !important',
                },
                '&:focus': {
                    outline: '0 !important',
                },
                '&:hover': {
                    outline: '0 !important',
                    '&::before': {
                        outline: '0 !important',
                        borderBottom: '1px solid white !important',
                    },
                },
            },
        },
        MuiIcon: {
            root: {},
        },
        MuiInputAdornment: {
            root: {
                color: 'white',
            },
            positionStart: {
                color: 'black',
            },
        },
        MuiTableRow: {
            hover: {
                '&:hover': {
                    backgroundColor: `${theme.color.common.contentHover} !important`,
                },
            },
        },
        MuiCheckbox: {
            root: {
                '&:hover': {
                    backgroundColor: `${theme.color.grey.lightest} !important`,
                },
                '&$checked': {
                    color: `${theme.color.primary.main} !important`,
                },
            },
        },
        MuiTableSortLabel: {
            root: {
                '&:hover': {
                    color: theme.color.font.dark,
                },
            },
        },
        MuiTableCell: {
            root: {
                padding: compact ? 8 : theme.spacing(2),
                fontSize: `12px !important`,
            },
            footer: {
                fontSize: theme.font.size.medium,
            },
            head: {
                fontWeight: theme.font.weight.bold,
            },
        },
        MuiTablePagination: {
            select: {
                paddingRight: theme.space.padding.default,
            },
            toolbar: {
                '& span': { color: theme.color.font.dark },
            },
        },
        MuiIconButton: {
            root: {
                padding: compact ? 5 : 12,
            },
        },
        MuiTableFooter: {
            root: {
                '& div': {
                    backgroundColor: theme.color.grey.lightest,
                    color: theme.color.font.dark,
                    borderRadius: toCssValue([0, 0, 5, 5]),
                    border: 'none',
                },
            },
        },
    },
});
//# sourceMappingURL=materialTableTheme.js.map